<template>
  <div class="field has-margin-bottom">
    <label class="label auth-ui-select-label has-negative-margin">
      {{ $t('admin.magicLinkMailingListSelectTemplateTitle') }}
    </label>
    <div
      v-if="selectedTemplate.name"
      class="auth-ui-card-box"
    >
      {{ selectedTemplate.name }}<span v-if="selectedTemplate.defaultTemplate">
        {{ $t('admin.magicLinkMailingListTemplateDefault') }}</span>,
      {{ selectedTemplate.id }}
    </div>
    <div
      v-else
      class="auth-ui-card-box"
    >
      {{ $t('admin.magicLinkMailingListTemplateDefault') }}
    </div>
    <div class="control auth-ui-row-container">
      <button
        class="button is-link auth-ui-pulled-right has-negative-margin"
        @click.prevent="toggleModal()"
      >
        {{ $t('admin.magicLinkMailingListChangeTemplate') }}
      </button>
    </div>
  </div>
</template>

<script>
/* ============
       * Template Section Component
       * ============
       *
       * Shows the selected template and a button for opening
       * a template selection modal.
       *
       * Used by the tabs of the "Mail Sends" component.
       *
       */
export default {
  name: 'TemplateSection',

  props: {
    selectedTemplate: {
      type: Object,
      default: () => {},
    },
    toggleModal: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
